<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="24">
        <div>
          <div v-if="integrationWizardIndex >= 0">
            <h3 v-if="integrationWizardIndex == 0" class="cnct-aws-header">AWS Account Configuration Setup</h3>
            <h3 v-if="integrationWizardIndex == 1" class="cnct-aws-header">Verify Connection Settings</h3>
            <h3 v-if="integrationWizardIndex == 2" class="cnct-aws-header">Success!</h3>
            <h3 v-if="integrationWizardIndex == 3" class="cnct-aws-header">Error!</h3>

            <el-steps 
              v-if="integrationWizardIndex <= 1"
              class="el-step-fixes"
              :active="integrationWizardIndex"
              finish-status="success"
            >
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item style="overflow: unset" :key="1">
              <p class="header-carousal-2">
                Copy the Role ARN at the output tab. The ARN will appear in the tab after ~30-60 seconds after you
                confirm the configuration.
              </p>
              <div class="box flex">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-row :type="'flex'" :gutter="8" class="mt-20">
                    <el-col>
                      <el-row :gutter="20">
                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Account Nickname"></el-form-item>
                          <el-input
                            v-model="integrationWizardData.nickName"
                            placeholder="Enter a nickname for your connection"
                            @keydown.native.space.prevent
                          ></el-input>
                        </el-col>
                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Confluera Role ARN"></el-form-item>
                          <el-input
                            v-model="integrationWizardData.roleArn"
                            placeholder="Enter your role ARN"
                            :disabled="true"
                          ></el-input>
                        </el-col>
                        <el-col :span="8" class="conf-block">
                          <el-form-item label="External ID"></el-form-item>
                          <el-input
                            v-model="integrationWizardData.externalId"
                            placeholder="Enter the External ID"
                            :disabled="true"
                          ></el-input>
                        </el-col>
                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Scan Frequency"></el-form-item>
                          <el-select
                            style="width: 100%"
                            v-model="integrationWizardData.scanFrequency"
                            placeholder="Select Frequency"
                          >
                            <el-option
                              v-for="item in [
                                { label: '1 Minute', value: 60000 },
                                { label: '3 Minute', value: 60000 * 3 },
                                { label: '5 Minute', value: 60000 * 5 }
                              ]"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-carousel-item>
            <el-carousel-item style="overflow: unset" :key="2">
              <el-row style="height: 100%">
                <h5 class="mb-39" style="text-transform: none; font-weight: normal">
                  Check Details on page before continuing
                </h5>
                <el-row class="check-details-on-pag format-text">
                  <el-col class="carousal-3-content">
                    <span>Account Nickname :</span>
                    <span class="normal-font">{{ integrationWizardData.nickName }} </span>
                  </el-col>
                  <el-col class="carousal-3-content">
                    <span>Confluera Role ARN :</span>
                    <span class="normal-font">{{ integrationWizardData.roleArn }} </span>
                  </el-col>
                  <el-col class="carousal-3-content">
                    <span>External ID :</span>
                    <span class="normal-font">{{ integrationWizardData.externalId }} </span>
                  </el-col>
                  <el-col class="carousal-3-content">
                    <span>Scan Frequency :</span>
                    <span class="normal-font">{{ integrationWizardData.scanFrequency/60000 }} mins </span>
                  </el-col>
                </el-row>
              </el-row>
            </el-carousel-item>
            <el-carousel-item :key="3" class="initiated mt-20">
              <!-- <h4 class="center-text">Initiated!</h4>
              <div class="box flex" v-loading="apiCall.outbound" element-loading-spinner="el-icon-loading"></div>
              <div class="box flex mt-20 mb-20">
                <p>
                  Please wait as we are attempting to connect to your AWS account. In a few minutes, we will discover
                  your VMs, containers, and cloud topology.
                </p>
              </div>
              <div class="box flex mt-20">
                <el-button size="medium" round @click="gotoIntegrationWorkflow">View Configured Account</el-button>
              </div>
              <div class="box mt-20">
                <router-link class="display-block " :to="{ name: 'hosts', query: { hostfilter: 'aws' } }">
                  <a>View discovered AWS instances</a>
                </router-link>
                <router-link class="display-block " :to="{ name: 'installation', query: { os: 'kubernetes' } }">
                  <a>Next Step: Setup Kubernetes Discovery</a>
                </router-link>
              </div> -->
              <div>
                <img src="/static/images/gcpSuccess.svg" alt="SUCCESS" />
              </div>
              <div class="initiated_message">
                <span>You've added your AWS Account assets. Now you'll be</span><br>
                <span>able to observe them in one secure environmemt.</span>
              </div>
              <div class="mt-25">
                <el-button
                type="primary"
                size="medium"
                style="background-color: #1A90FA;"
                @click="gotoIntegrationWorkflow"
               >Cloud Accounts</el-button>
              </div>
              <div class="initiated_message mt-20">
                <span>You can now add <strong>Kubernetes</strong> for your AWS Account.</span>
                <router-link class="display-block " :to="{ name: 'installation', query: { os: 'kubernetes' } }">
                  <a>Set up Kubernetes</a>
                </router-link><br>
                <span>View <strong>Discovered Instances</strong> for your AWS Account.</span>
                <router-link class="display-block " :to="{ name: 'hosts', query: { hostfilter: 'aws' } }">
                  <a>Discovered instances</a>
                </router-link>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4" class="initiated error mt-20">
              <!-- <h4 class="center-text">Error!</h4>
              <div class="box flex">
                <span class="center-text error-icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              </div>
              <div class="box mt-20 mb-20 error-message">
                <p>
                  We could not connect to your AWS account.
                </p>
                <p>
                  Troubleshoot to fix your configuration.
                </p>
                <div v-if="apiCall.error" class="box mt-20">
                  <p>
                    {{ apiCall.errorMsg.code }}:
                    {{ apiCall.errorMsg.message }}
                  </p>
                </div>
              </div>
              <div class="box flex mt-40">
                <el-button size="medium" round @click="loadDocumentation('page-cloud')">Troubleshoot / FAQs</el-button>
              </div> -->
              <div>
                <img src="/static/images/gcpError.svg" alt="ERROR" />
              </div>
              <div class="initiated_message mt-60">
                <span><b>Could Not Connect</b></span><br>
                <span>We could not connect to your AWS account.</span><br>
                <span>Troubleshoot to fix your configuration.</span><br><br>
                <span>invalid-integration-config: the integration configuration was invalid.</span>
              </div>
              <div class="mt-89">
                <el-button
                type="primary"
                size="medium"
                style="background-color: #1A90FA;"
                @click="loadDocumentation('page-cloud-aws')"
               >Troubleshoot</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex">
            <span
              v-if="integrationWizardIndex >= 1 && integrationWizardIndex != 2 && integrationWizardIndex != 3"
              class="text-underline cursor-pointer back-button go-back-button"
              @click="backIntegrationStep"
              >Back
            </span>
            <el-button
              class="verify-button"
              v-else-if="integrationWizardIndex == 0"
              size="medium"
              round
              @click="validateNickName"
            >
              Verify
            </el-button>
            <el-button
              class="submit-button"
              v-if="integrationWizardIndex == 1"
              size="medium"
              round
              @click="updateIntegrationSettings"
            >
              Update
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'

import { AWS_CONNECTION_SETTINGS_UPDATE_REQUEST } from '@/store/modules/integrations/aws-connection-settings.type'
import { INTEGRATIONS_LIST_REQUEST } from '@/store/modules/integrations/integrations.type'
import { CLOUD_ACCOUNTS_LIST_REQUEST } from '@/store/modules/integration_accounts/integration-accounts.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'EditAwsIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      integrationLastStep: 3,
      integrationWizardSteps: [
        'Go to IAM console->Roles',
        'Create new role',
        'Select "Another AWS Account"',
        'Put Account# of Confluera <829699521465>',
        'Put External ID# of Confluera <a345aj-sxsax-1jwdewdw>',
        'Select and attach two policies: AWSConfigRole policy and AWSConfigUserAccess policy',
        'Create role (e.g. ConfigAccessRole)'
      ],
      apiCall: {
        outbound: false,
        error: false,
        errMsg: ''
      }
    }
  },
  methods: {
    removeSpaces () {
      console.log('in blur')
      this.integrationWizardData.nickName = this.integrationWizardData.nickName.split(' ').join('')
    },
    gotoIntegrationWorkflow () {
      this.$router.push({
        name: 'discoveryintegration-accounts'
      })
    },
    updateIntegrationSettings () {
      this.apiCall.outbound = true
      this.$store.dispatch(AWS_CONNECTION_SETTINGS_UPDATE_REQUEST, this.integrationWizardData).then(
        resp => {
          this.nextIntegrationStep()
          this.apiCall.outbound = false
        },
        errMsg => {
          this.nextIntegrationStep()
          this.apiCall.error = true
          this.apiCall.errorMsg = errMsg
        }
      )
    },
    callApi () {
      this.$store.dispatch(INTEGRATIONS_LIST_REQUEST).then(integrations => {
        this.$store.dispatch(CLOUD_ACCOUNTS_LIST_REQUEST).then(agents => {
          this.apiCalled = true
          for (let cloudIntegrationAccount of this.cloudIntegrationAccounts.models) {
            if (this.$route.params.accountKey === cloudIntegrationAccount.accountKey) {
              this.integrationWizardData = cloudIntegrationAccount.config
              this.integrationWizardData.accountKey = cloudIntegrationAccount.accountKey
              this.integrationWizardData.active = true
              this.integrationWizardData.key = cloudIntegrationAccount.accountKey
            }
          }
        })
      })
    }
  },
  created () {
    if (!_.isEmpty(this.awsConnection)) {
      this.integrationWizardData = this.awsConnection
    }
    if (!this.$_.isEmpty(this.$route.params) && this.integrationWizardData.active === null) {
      this.callApi()
    }
  },
  computed: {
    ...mapGetters(['awsConnection', 'cloudIntegrationAccounts'])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.integration-settings {
  overflow: unset;
}

.initiated {
  h4 {
    margin-bottom: 40px;
  }

  p {
    text-align: center;
    width: 60%;
    margin: auto;
    display: block;
  }

  >>> .el-button {
    margin: auto;
  }

  >>> .el-icon-loading,
  .material-icons {
    font-size: 2em;
  }

  .center-text.error-icon {
    margin: auto;
    font-size: 2em;
  }
}

>>> .el-carousel--horizontal {
  overflow-x: hidden;
  width: 110%;
}

>>> .el-step__head.is-success {
  color: #1a90fa;
}

>>> .el-step__head {
  fill: #1a90fa;
  border-color: #1a90fa;
}

>>> .el-step__line {
  background-color: #1a90fa;
}

>>> .el-step__icon-inner {
  color: #1a90fa;
}

.el-form-item {
  margin-bottom: 0px;
}
.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}

.error-message {
  width: 60%;
  margin: 30px auto;

  p {
    width: 100%;
  }
}

.aws-logo-box {
  box-sizing: border-box;
  height: 172px;
  width: 172px;
  border: 1px solid #979797;
  border-radius: 6px;
  align-content: center;
}

.top-header {
  height: 94px;
  width: 834px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0.17px;
  line-height: 22px;
}

.top-header-title {
  font-weight: 500px;
  font-size: 24px;
  margin-bottom: 22px;
}
.aws-content {
  height: 308px;
  width: 616px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.start-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  margin-left: 55%;
  text-align: center;
  margin-top: 50px;
}

.submit-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  /* margin-left:55%; */
  text-align: center;
}

.go-back-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #ffffff;
  margin-left: 55%;
  text-align: center;
  border: 1px solid #767676;
  text-decoration: none;
}

.verify-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  margin-left: 70%;
  text-align: center;
}

.conf-block {
  display: inline-block;
  width: 34.86%;
  height: 27.34%;
  line-height: 20px;
  letter-spacing: 0.09px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 50px;
}

.header-carousal-2 {
  height: 44px;
  width: 676px;
  color: #454b60;
  /* font-family: Montserrat; */
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 22px;
}

.carousal-3-content {
  margin-bottom: 20px;
  font-size: 14px;
}

.integration-settings {
  .el-steps {
    padding: 20px 10px 25px 10px;
    margin: 0 0 20px 0;
    border-bottom: solid 1px #f0f0f0;
  }

  >>> .el-carousel {
    margin: 10px 0 30px 0;

    .el-carousel__container {
      height: 440px;
    }
  }
}

.cnct-aws-header {
  margin-bottom: 20px;
  margin-top: 10px;
  font-weight: 500px;
  font-size: 24px;
  color: #454b60;
}

.el-step-fixes {
  width: 20%;
  padding-left: 0px;
  border: none;
}

.format-text {
  font-weight: bold;
  color: #454b60;
}

.check-details-on-pag {
  height: 198px;
  width: 551px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 22px;
}

.normal-font {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/edit/EditAwsIntegrationWorkflow.vue